import { addMonths, subMonths } from 'date-fns'
import { QuarterPeriod } from './periodOptions'

export type DateRange = {
  startDate: Date
  endDate: Date
}

type Input =
  | {
      period: QuarterPeriod
    }
  | {
      period: 'last3months'
      now: Date
    }
export const periodToDateRange = (input: Input) => {
  if (input.period === 'last3months') {
    return calculateLast3Months(input.now)
  }

  return calculateQuarterRange(input.period)
}
/**
 * 四半期期間を日付範囲に変換する
 * 型安全性により、期間フォーマットと四半期の値は保証されている
 */
const calculateQuarterRange = (period: QuarterPeriod): DateRange => {
  // 型で保証されているので、ここでは非nullアサーションを使用
  const match = period.match(/^(\d{4})q([1-4])$/)!
  const year = parseInt(match[1]!)
  const quarter = parseInt(match[2]!)

  // 四半期の開始月を計算
  const startMonth = (quarter - 1) * 3 + 1

  // 開始日: 四半期の最初の月の1日
  const startDate = new Date(Date.UTC(year, startMonth - 1, 1))

  // 終了日: 3ヶ月後の月初
  const endDate = addMonths(startDate, 3)

  return { startDate, endDate }
}

/**
 * 直近3ヶ月の日付範囲を計算する
 */
const calculateLast3Months = (now: Date): DateRange => {
  // 3ヶ月前の年月を計算
  const threeMonthsAgo = subMonths(now, 2)
  const startYear = threeMonthsAgo.getUTCFullYear()
  const startMonth = threeMonthsAgo.getUTCMonth()
  const startDate = new Date(Date.UTC(startYear, startMonth, 1))

  // 現在月の翌月初を計算
  const nextMonth = addMonths(now, 1)
  const endYear = nextMonth.getUTCFullYear()
  const endMonth = nextMonth.getUTCMonth()
  const endDate = new Date(Date.UTC(endYear, endMonth, 1))

  return { startDate, endDate }
}
